<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <button type="button" id="btnadd" class="btn btn-primary btn-xs" @click="btnadd">
          <font-awesome-icon icon="plus" />
          {{ translation(11955) }}
        </button>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(11953) }}</span>
      </div>
    </div>
    <div class="row margin20">
      <div class="col-md-12">
        <span id="lblinfo" v-html="translation(11954)"></span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <XVtableV2
          :filterfunc="filterfunc"
          :tablesetting="inzageTable.tablesetting"
          :tablecolumnsetting="inzageTable.tablecolumnsetting"
          :tabledata="inzageTable.tabledata"
          :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
          v-on:sortXVTable="XVTablesort"
          :tableSearchBox="tablesearchboxvisible"
        >
          <template slot="tblPersonWijzig" slot-scope="dr">
            <span :id="'wijzig_' + [dr.index]" @click="wijzigPersoon(dr)" :title="translation(14764)">
              <font-awesome-icon
                :icon="['far', 'calendar-edit']"
                class="initial pointer"
                v-bind:class="{ hideIcon: dr.row.tableRowState.editModus }"
              />
              <font-awesome-icon
                icon="chevron-up"
                class="initial pointer"
                v-bind:class="{ hideIcon: !dr.row.tableRowState.editModus }"
              />
            </span>
          </template>
          <template slot="tblPersonVerwijder" slot-scope="dr">
            <span :id="'verwijder_' + [dr.index]" @click="openConfirm(dr)" :title="translation(150)">
              <font-awesome-icon :icon="['fa', 'trash']" class="initial pointer" />
            </span>
          </template>
          <template slot="detailrow" slot-scope="tablerow">
            <div class="margin20"></div>
            <div class="row" v-if="rollen.length > 1 && tablerow.row.tableRowState.editModus">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(11968) }}</label>
                <XVhelpcontrol :helptext="translation(11969)" class="pull-right"></XVhelpcontrol>
              </div>
              <div
                class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback"
                v-bind:class="{ 'form-group--error': errors.has('ddrolwijzig' + tablerow.index) }"
              >
                <XVdropdown
                  :id="'ddrolwijzig_' + tablerow.index"
                  v-model="tablerow.row.tableRowState.rolSelected"
                  :name="'ddrolwijzig' + tablerow.index"
                  :data-vv-as="translation(11968)"
                  v-validate="validationWijzigRol"
                  v-if="rollen.length >= 1"
                  @input="selectRolwijzig(tablerow)"
                  :value="tablerow.row.tableRowState.rolSelected"
                  :datalist="rollen"
                ></XVdropdown>
                <span class="form-group__message">{{ errors.first('ddrolwijzig' + tablerow.index) }}</span>
                <span v-html="translation(9377)" v-if="rollen.length === 0"></span>
              </div>
            </div>
            <XVbootstraprow
              :class="'margin20'"
              id="lblrolrow"
              :label="translation(11968)"
              :helptext="translation(11969)"
              v-if="
                XSvisible &&
                inzageTable.tablecolumnsetting[7].visible === 1 &&
                !tablerow.row.tableRowState.editModus &&
                rollen.length > 1
              "
              >{{ tablerow.row.rol }}</XVbootstraprow
            >
            <XVbootstraprow
              id="lblprofgrouprow"
              :label="translation(11970)"
              :helptext="translation(11971)"
              v-if="
                XSvisible && inzageTable.tablecolumnsetting[7].visible === 1 && !tablerow.row.tableRowState.editModus
              "
              >{{ tablerow.row.tblProfGroup }}</XVbootstraprow
            >
            <div
              class="row"
              v-if="
                tablerow.row.tableRowState.editModus &&
                selectprofgroups === 2 &&
                tablerow.row.tableRowState.cblProfgroupoptions
              "
            >
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(11970) }}</label>
                <XVhelpcontrol :helptext="translation(11971)" class="pull-right"></XVhelpcontrol>
              </div>
              <div
                class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback"
                v-bind:class="{ 'form-group--error': errors.has('cblProfgroupoptions' + tablerow.index) }"
              >
                <XVcheckboxlist
                  :id="'cblProfgroupoptions_' + tablerow.index"
                  v-model="tablerow.row.tableRowState.cblProfgroupchecked"
                  :name="'cblProfgroupoptions' + tablerow.index"
                  :data-vv-as="translation(11970)"
                  v-validate="validationWijzigRol"
                  :datalist="tablerow.row.tableRowState.cblProfgroupoptions"
                  v-show="tablerow.row.tableRowState.cblProfgroupoptions.length >= 1"
                ></XVcheckboxlist>
                <span class="form-group__message">{{ errors.first('cblProfgroupoptions' + tablerow.index) }}</span>
                <span
                  v-html="translation(11964)"
                  v-if="tablerow.row.tableRowState.cblProfgroupoptions.length === 0"
                ></span>
              </div>
            </div>
            <XVbootstraprow id="lblemailrow" :label="translation(11976)" v-if="XSvisible">
              {{ tablerow.row.tblPersonAutorisedAdminEmail }}
            </XVbootstraprow>
            <XVbootstraprow id="lbldatumaangemaaktrow" :label="translation(11958)" v-if="XSvisible">
              {{ tablerow.row.tblPersonAutorisedAdminDateCreated }}
            </XVbootstraprow>
            <div class="row" v-show="tablerow.row.tableRowState.editModus" :class="{ margin20: wMD || wLG || wXL }">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(11972) }}</label>
              </div>
              <div
                class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback"
                v-bind:class="{ 'form-group--error': errors.has('tbxDatum' + tablerow.index) }"
              >
                <XVdate
                  :id="'tbxDatum_' + tablerow.index"
                  v-model="tablerow.row.tableRowState.datumSelected"
                  :name="'tbxDatum' + tablerow.index"
                  :data-vv-as="translation(11972)"
                  v-validate="{ XVDateDefault: true, required: true }"
                ></XVdate>
                <span class="form-group__message">{{ errors.first('tbxDatum' + tablerow.index) }}</span>
              </div>
            </div>
            <div class="row XVtablebtnrow">
              <div class="col-md-12">
                <div class="btn-group XVtablerowbtngroup">
                  <button
                    :id="'btnSave' + tablerow.index"
                    type="button"
                    class="btn btn-primary XVtablerowbutton"
                    @click.prevent="btnSaveRow(tablerow)"
                    v-show="tablerow.row.tableRowState.editModus"
                  >
                    <font-awesome-icon :icon="['far', 'save']" />
                    {{ translation(14702) }}
                  </button>
                  <button
                    :id="'btnCancelRow' + tablerow.index"
                    type="button"
                    class="btn btn-primary XVtablerowbutton"
                    @click.prevent="btnCancelRow(tablerow.index)"
                    v-show="tablerow.row.tableRowState.editModus"
                  >
                    <font-awesome-icon icon="times" />
                    {{ translation(17) }}
                  </button>
                </div>
                <div class="btn-group XVtablerowbtngroup">
                  <button
                    :id="'btnWijzigRow' + tablerow.index"
                    type="button"
                    class="btn btn-primary XVtablerowbutton"
                    @click.prevent="btnWijzigRow(tablerow)"
                    v-show="!tablerow.row.tableRowState.editModus && (wXS === true || wSM === true || wMD === true)"
                  >
                    <font-awesome-icon :icon="['far', 'calendar-edit']" />
                    {{ translation(14589) }}
                  </button>
                  <button
                    :id="'btnVerwijder' + tablerow.index"
                    type="button"
                    class="btn btn-primary XVtablerowbutton"
                    @click.prevent="openConfirm(tablerow)"
                    v-show="!tablerow.row.tableRowState.editModus && (wXS === true || wSM === true || wMD === true)"
                  >
                    <font-awesome-icon :icon="['fa', 'trash']" />
                    {{ translation(150) }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </XVtableV2>
        <modal v-model="showConfirm" title="Modal 1" ref="modal" id="modal-demo" :header="false">
          <p v-html="translation(15461)"></p>
          <div slot="footer" class="modalconfirmbuttons">
            <button
              id="btnDeleteModal"
              type="button"
              class="btn btn-primary modalconfirmbutton"
              @click.prevent="deleteConfirm()"
            >
              {{ translation(23) }}
            </button>
            <button
              id="btnCloseModal"
              type="button"
              class="btn btn-primary modalconfirmbutton"
              @click.prevent="closeConfirm"
            >
              {{ translation(17) }}
            </button>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
'use strict'
// https://pe.xaurum.nl/peapp/prof/Spe015PrPersonAutorisedAdmin/overview
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin, util } from 'pevueglobal'

export default {
  mixins: [FAMixin],
  data: function () {
    return {
      showConfirm: false,
    }
  },
  async mounted() {
    await this.getTexten()
    await this.getXVtable()
    await this.getRollenProfgroups()
    this.setFormReset()
    this.stopLoading()
  },
  computed: {
    ...mapGetters('Spe015PrPersonAutorisedAdmin', [
      'inzageTable',
      'rollen',
      'profgroups',
      'XVtableGetValue',
      'selectprofgroups',
      'rolSelected',
      'adminprofgroups',
    ]),
    tablesearchboxvisible: function () {
      // searchbox pas zichtbaar als er meer dan 10 items in tabel staan
      if (this.inzageTable.tabledata.length >= 10) {
        return true
      } else {
        return false
      }
    },
    XSvisible: function () {
      if (this.wXS || this.wSM || this.wMD) {
        return true
      } else {
        return false
      }
    },
    validationWijzigRol() {
      if (this.selectprofgroups === 2) {
        return 'required'
      } else {
        return ''
      }
    },
  },
  methods: {
    ...mapActions('Spe015PrPersonAutorisedAdmin', [
      'getTexten',
      'getXVtable',
      'getRollenProfgroups',
      'getAdminProfgroups',
      'updatePerson',
      'deletePerson',
    ]),
    ...mapMutations('Spe015PrPersonAutorisedAdmin', [
      'XVtableSetRowStateProperty',
      'setProgroupsWijzigOverzicht',
      'setFormReset',
      'XVTablesort',
    ]),
    ...mapMutations(['addNotification']),
    filterfunc: function (tabledata) {
      return tabledata
    },
    btnadd() {
      this.setFormReset()
      this.$router.push({ path: 'add' })
    },
    selectRolwijzig(tablerow) {
      let pg = this.profgroups.filter(
        (rij) => rij.tblTypeAdministratorID === parseInt(tablerow.row.tableRowState.rolSelected)
      )
      this.XVtableSetRowStateProperty({
        index: tablerow.index,
        stateProperty: 'cblProfgroupoptions',
        statePropertyValue: pg,
      })
      let profgroupchecked = []
      if (this.selectprofgroups === 0 || this.selectprofgroups === 1) {
        pg.forEach((element) => {
          profgroupchecked.push(element.value)
        })
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'cblProfgroupchecked',
          statePropertyValue: profgroupchecked,
        })
      }
      if (this.selectprofgroups === 2) {
        let pgchecked = this.adminprofgroups.filter(
          (rij) => rij.tblPersonAutorisedAdminID === tablerow.row.tblPersonAutorisedAdminID
        )
        let pgarray = []
        pg.forEach((element) => {
          pgarray.push(element.value)
        })
        let pgcheckedarray = []
        pgchecked.forEach((element) => {
          pgcheckedarray.push(element.value)
        })
        let filteredArr = pgarray.filter((p) => pgcheckedarray.indexOf(p) !== -1)
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'cblProfgroupchecked',
          statePropertyValue: filteredArr,
        })
      }
    },
    async wijzigPersoon(tablerow) {
      if (tablerow.row.tableRowState.editModus === false) {
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rowVisible',
          statePropertyValue: true,
        })
        this.XVtableSetRowStateProperty({ index: tablerow.index, stateProperty: 'editModus', statePropertyValue: true })
        let datum = this.XVtableGetValue({
          index: tablerow.index,
          columnname: 'tblPersonAutorisedAdminDateUpTo',
        })
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'datumSelected',
          statePropertyValue: datum,
        })
        let rolvalue
        if (this.rollen.length > 1) {
          let rol = this.rollen.filter(
            (rij) => rij.labelText === this.XVtableGetValue({ index: tablerow.index, columnname: 'Rol' })
          )
          rolvalue = rol[0].value
        } else {
          rolvalue = this.rollen[0].value
        }
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rolSelected',
          statePropertyValue: rolvalue,
        })
        let pg = this.profgroups.filter((rij) => rij.tblTypeAdministratorID === tablerow.row.tableRowState.rolSelected)
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'cblProfgroupoptions',
          statePropertyValue: pg,
        })
        await this.getAdminProfgroups(tablerow.row.tblPersonAutorisedAdminID)

        let pgchecked = this.adminprofgroups.filter(
          (rij) => rij.tblPersonAutorisedAdminID === tablerow.row.tblPersonAutorisedAdminID
        )
        let profgroupchecked = []
        pgchecked.forEach((element) => {
          profgroupchecked.push(element.value)
        })
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'cblProfgroupchecked',
          statePropertyValue: profgroupchecked,
        })
      } else {
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rowVisible',
          statePropertyValue: false,
        })
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'editModus',
          statePropertyValue: false,
        })
      }
    },
    btnCancelRow(index) {
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'datumSelected', statePropertyValue: null })
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'rolSelected', statePropertyValue: null })
      if (this.wXS || this.wSM) {
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'rowVisible', statePropertyValue: true })
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'editModus', statePropertyValue: false })
      } else {
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'rowVisible', statePropertyValue: false })
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'editModus', statePropertyValue: false })
      }
    },
    async btnWijzigRow(tablerow) {
      this.XVtableSetRowStateProperty({ index: tablerow.index, stateProperty: 'rowVisible', statePropertyValue: true })
      this.XVtableSetRowStateProperty({ index: tablerow.index, stateProperty: 'editModus', statePropertyValue: true })
      let datum = this.XVtableGetValue({ index: tablerow.index, columnname: 'tblPersonAutorisedAdminDateUpTo' })
      this.XVtableSetRowStateProperty({
        index: tablerow.index,
        stateProperty: 'datumSelected',
        statePropertyValue: datum,
      })
      let rolvalue
      if (this.rollen.length > 1) {
        let rol = this.rollen.filter(
          (rij) => rij.labelText === this.XVtableGetValue({ index: tablerow.index, columnname: 'Rol' })
        )
        rolvalue = rol[0].value
      } else {
        rolvalue = this.rollen[0].value
      }
      this.XVtableSetRowStateProperty({
        index: tablerow.index,
        stateProperty: 'rolSelected',
        statePropertyValue: rolvalue,
      })
      let pg = this.profgroups.filter((rij) => rij.tblTypeAdministratorID === tablerow.row.tableRowState.rolSelected)
      this.XVtableSetRowStateProperty({
        index: tablerow.index,
        stateProperty: 'cblProfgroupoptions',
        statePropertyValue: pg,
      })
      await this.getAdminProfgroups(tablerow.row.tblPersonAutorisedAdminID)

      let pgchecked = this.adminprofgroups.filter(
        (rij) => rij.tblPersonAutorisedAdminID === tablerow.row.tblPersonAutorisedAdminID
      )
      let profgroupchecked = []
      pgchecked.forEach((element) => {
        profgroupchecked.push(element.value)
      })
      this.XVtableSetRowStateProperty({
        index: tablerow.index,
        stateProperty: 'cblProfgroupchecked',
        statePropertyValue: profgroupchecked,
      })
    },

    btnSaveRow(tablerow) {
      this.$validator.validate().then((result) => {
        let rollenInput = ''
        if (this.rollen.length === 1 && this.rollen.length !== 0) {
          rollenInput = this.rollen[0].value
        } else if (this.rollen.length !== 1 && this.rollen.length !== 0) {
          rollenInput = tablerow.row.tableRowState.rolSelected
        }
        if (result) {
          let datum = util.DateForDatabase(tablerow.row.tableRowState.datumSelected)
          let updateString = {
            InsTblPersonAutorisedAdminID: tablerow.row.tblPersonAutorisedAdminID,
            InsTblTypeAdministratorID: rollenInput,
            TblPersonAutorisedAdminDateUpTo: datum,
            selectprofgroups: this.selectprofgroups,
            profgroups: tablerow.row.tableRowState.cblProfgroupchecked,
          }
          this.updatePerson(updateString)

          this.XVtableSetRowStateProperty({
            index: tablerow.index,
            stateProperty: 'editModus',
            statePropertyValue: false,
          })

          this.XVtableSetRowStateProperty({
            index: tablerow.index,
            stateProperty: 'rowVisible',
            statePropertyValue: false,
          })
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
    openConfirm: function (tablerow) {
      this.showConfirm = true
      this.selectedUser = tablerow.row.tblPersonAutorisedAdminID
    },
    closeConfirm: function () {
      this.showConfirm = false
    },
    deleteConfirm: function () {
      this.deletePerson(this.selectedUser)
      this.showConfirm = false
    },
  },
}
</script>
